module.exports = __webpack_public_path__ + "static/media/chicky_head.e067703c.png";